<section class="content">
    <div class="container-fluid">
        <mat-card class="mat-elevation-z0">
            <form class="col-lg-12" [formGroup]="organisationForm" *ngIf="!loading">
                <section formGroupName="organisation">

                    <mat-form-field class="col-md-12">
                        <mat-label>Name</mat-label>
                        <input matInput type="text" formControlName="name" />
                    </mat-form-field>

                    <app-address-card-input
                        class="col-lg-12" 
                        label="Address"
                        formControlName="address"
                    ></app-address-card-input>

                    <mat-form-field class="col-md-3">
                        <mat-label>bcitiId</mat-label>
                        <input matInput type="text" formControlName="bcitiId" />
                    </mat-form-field>

                    <mat-form-field class="col-md-3" hintLabel="">
                        <mat-label>Time Zone</mat-label>
                        <mat-select formControlName="timeZone">
                            <mat-option [value]=""></mat-option>
                            <mat-option *ngFor="let timezone of timezones" [value]="timezone">
                                {{ timezone }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-md-3" hintLabel="">
                        <mat-label>Country Tag</mat-label>
                        <mat-select formControlName="countryTag">
                            <mat-option [value]=""></mat-option>
                            <mat-option *ngFor="let country of countries" [value]="country">
                                {{ country }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-md-3" hintLabel="">
                        <mat-label>State Short Code</mat-label>
                        <mat-select formControlName="stateShortCode">
                            <mat-option [value]=""></mat-option>
                            <mat-option *ngFor="let stateCode of stateShortCodeOptions" [value]="stateCode">
                              {{ stateCode }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="col-md-12">
                        <mat-label>Channels</mat-label>
                        <mat-selection-list formControlName="configuredChannels" class="col-md-12">
                            <mat-list-option
                            *ngFor="let channel of channels"
                            [value]="channel"
                            checkboxPosition="before"
                            >
                            {{ channelLabels[channel] || channel }}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>

                    <div class="col-md-12">
                        <mat-label>Hidden</mat-label>
                        <br />
                        <mat-slide-toggle formControlName="hidden"></mat-slide-toggle>
                    </div>
                </section>

                <div class="actions" *ngIf="displayActions">
                    <div class="warning" *ngIf="organisationForm.dirty">You have unsaved changes.</div>
                    <div>
                        <mat-spinner [diameter]="36" *ngIf="loading"></mat-spinner>
                    </div>
                    <button mat-raised-button [disabled]="saveLoading || loading" (click)="submitOrganisation()" color="primary">
                        Save
                        <mat-icon *ngIf="saveLoading">
                            <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
                        </mat-icon>
                    </button>
                </div>
            </form>
        </mat-card>

    </div>
</section>